<ng-container [ngSwitch]="layout$ | async">
  <ng-container *ngSwitchCase="layouts.Default">
    <ng-container *ngIf="statusMessage$ | async as statusMessage">
      <app-modal
        *ngIf="isShowStatusMessage"
        [title]="statusMessage.title"
        i18n-title
        (closeModal)="isShowStatusMessage = false"
        [isDialog]="!!statusMessage.dialog"
      >
        <div class="modal-message h4" *ngIf="isMessageArray">
          <p *ngFor="let line of $any(statusMessage.message)">
            {{ line }}
          </p>
        </div>
        <div class="modal-message h4" *ngIf="!isMessageArray">
          {{ statusMessage.message }}
        </div>
        <ng-container footer>
          <button *ngIf="!statusMessage.dialog" type="button" mat-flat-button color="accent" (click)="isShowStatusMessage = false" class="modal-footer-button">
            <span i18n="@@Ok">Ok</span>
          </button>

          <div *ngIf="statusMessage.dialog" class="button-panel _center l-wrapper">
            <div class="button-panel__col" *ngFor="let button of statusMessage.dialog.buttons">
              <button type="button" mat-flat-button [color]="button.type" (click)="button.onClick(); isShowStatusMessage = false">
                <span>{{ button.text }}</span>
              </button>
            </div>
          </div>
        </ng-container>
      </app-modal>
    </ng-container>

  </ng-container>

  <ng-container *ngSwitchCase="layouts.Fresh">
    <div *ngIf="statusMessage$ | async as statusMessage">
      <app-modal
        *ngIf="isShowStatusMessage"
        [isDialog]="!!statusMessage.dialog"
        [additionalClass]="'_info'"
        [swipeDirection]="'bottom'"
        (closeModal)="onClose()"
        class="modal-info"
      >
        <div class="modal-info__image">
          <img *ngIf="statusMessage.type === 'error'" ngSrc="./assets/images/error@2x.png" alt="logo" width="163" height="160">
          <img *ngIf="statusMessage.type === 'warning'" ngSrc="./assets/images/warning@2x.png" alt="logo" width="150" height="157">
        </div>

        <div class="modal-info__title h1">
          <p>{{ statusMessage.title }}</p>
        </div>

        <div class="modal-info__message h4" *ngIf="isMessageArray">
          <p *ngFor="let line of $any(statusMessage.message)">
            {{ line }}
          </p>
        </div>
        <div class="modal-info__message h4" *ngIf="!isMessageArray">
          {{ statusMessage.message }}
        </div>

        <div class="modal-info__footer">
          <button *ngIf="!statusMessage.dialog" type="button"
                  (click)="isShowStatusMessage = false"
                  class="button button--th-main">
            <span i18n="@@Ok">Ok</span>
          </button>
        </div>

        <div class="modal-info__footer" *ngIf="statusMessage.dialog"
             [ngClass]="{'_multiple': statusMessage.dialog.buttons.length > 1}">
          <ng-container *ngFor="let button of statusMessage.dialog.buttons">
            <button type="button" class="button button--th-main" (click)="button.onClick();
                  isShowStatusMessage = false">
              <span>{{ button.text }}</span>
            </button>
          </ng-container>
        </div>

      </app-modal>
    </div>
  </ng-container>
</ng-container>
